module.exports = __webpack_public_path__ + "assets/Retina-Light.1e6c88800c670f9ee8bf0e2edb9b873f.woff2";